import { Anchor, Button, Container, Image, Separator, Text } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import AnalyticsService from '../services/AnalyticsService';
import ZebraPadding from '../components/common/ZebraPadding';
import { RouteService } from '../services/RouteService';
import LanguageStore from '../stores/LanguageStore';
import { IRouteStore } from '../stores/RouteStore';
import { ITranslateStore } from '../stores/TranslateStore';

interface IDirectPaymentReturnProps {
  notification: JSX.Element;
  translateStore?: ITranslateStore;
  routeService?: RouteService;
  routeStore?: IRouteStore;
  languageStore?: LanguageStore;
  analyticsService?: AnalyticsService;
}

@inject('translateStore', 'routeService', 'routeStore', 'analyticsService', 'languageStore')
@observer
export default class DirectPaymentReturn extends React.Component<IDirectPaymentReturnProps> {
  public render(): JSX.Element {
    const Notification = this.props.notification;
    const translate = this.props.translateStore.translate;
    const language = this.props.languageStore.upperCaseThreeCharLangPrefix.toLowerCase();
    return (
      <ZebraPadding>
        <Container>
          <Text className="text-center">
            {Notification}
            <Separator spacing="small" color="invisible" />
            <p className="text__margin-double">{translate('direct-payment-return.where-to-check-services')}</p>
            <Button
              text={translate('direct-payment-return.back-to-selfservice')}
              iconLeft="#login"
              className="text__margin-double"
              onClick={() => this.props.routeStore.goToExternalUrl('/')}
            />
            <Separator spacing="medium" color="invisible" />
            <Anchor url="/pakkumised">
              <Image
                srcset={`https://res.cloudinary.com/telia/image/upload/w_1024,fl_lossy,f_auto,q_auto:best/diil/teenused/banner_${language}.png 1024w,
              https://res.cloudinary.com/telia/image/upload/w_2048,fl_lossy,f_auto,q_auto:best/diil/teenused/banner_${language}.png 2048w`}
                width={1180}
                align="center"
                role="presentation"
              />
            </Anchor>
          </Text>
        </Container>
      </ZebraPadding>
    );
  }
}
